import { combineEpics, ofType } from 'redux-observable'
import { of } from 'rxjs'
import { catchError, filter, map, mergeMap, takeUntil } from 'rxjs/operators'

import { URL_CONST } from 'utils/urlConsts'
import { matchURL } from 'utils/urls'

import { selectHasSelectedCompanyFilterAccess } from 'containers/App/selectors'
import { FETCH_SELECTED_COMPANY_DATA_ASYNC } from 'containers/PartnerOptions/constants'
import { addToast } from 'containers/Toasts/actions'

import {
  fetchDataError,
  fetchDataSuccess,
  submitMailboxUpdateError,
  submitMailboxUpdateSuccess,
} from './actions'
import { FETCH_DATA, SUBMIT_MAILBOX_UPDATE } from './constants'

const fetchDataEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(
      FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS,
      FETCH_DATA.INITIATE,
      SUBMIT_MAILBOX_UPDATE.SUCCESS
    ),
    filter((action) => {
      if (action.type === FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS)
        return matchURL(URL_CONST.dashboard.home)
      return true
    }),
    mergeMap(() =>
      !selectHasSelectedCompanyFilterAccess(state$.value)
        ? of(FETCH_DATA.cancel())
        : api.dashboard.getMailboxesData(state$.value.partnerOptions.selectedCompany?.value).pipe(
            map((response) => fetchDataSuccess(response)),
            catchError((error) => of(epicsErrorHandler(fetchDataError, error))),
            takeUntil(action$.pipe(ofType(FETCH_DATA.CANCEL)))
          )
    )
  )

const submitMailboxUpdateEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(SUBMIT_MAILBOX_UPDATE.INITIATE),
    mergeMap(() =>
      api.dashboard
        .updateMailboxesData(
          state$.value.partnerOptions.selectedCompany?.value,
          state$.value.dashboard.home.mailboxesStatus.mailboxesToAdd
        )
        .pipe(
          mergeMap((response) =>
            of(
              submitMailboxUpdateSuccess(response),
              addToast({
                message: 'The email was successfully sent',
              })
            )
          ),
          catchError((error) =>
            of(
              epicsErrorHandler(submitMailboxUpdateError, error),
              addToast({
                message: error.response?.message || error?.response,
                type: 'error',
              })
            )
          ),
          takeUntil(action$.pipe(ofType(SUBMIT_MAILBOX_UPDATE.CANCEL)))
        )
    )
  )

export default combineEpics(fetchDataEpic, submitMailboxUpdateEpic)
